export const PLATFORMS_URL = '/platforms';
export const UNAUTHORIZED_PATH = '/unauthorized';
export const FORGOT_PASSWORD_URL = '/forgot-password';
export const RESET_PASSWORD_URL = '/reset-password';
export const SINGLE_SIGN_ON_CHALLENGE_URL = '/authentication/api/open/sso/challenge';
export const LOGIN_URL = window.ENV?.authProvider === 'sso' ? '/single-sign-on' : '/login';
